/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CoachSmallList = {
    type: 'array',
    contains: {
        type: 'CoachSmall',
    },
} as const;
